import { post, put, get } from "../../api";
import { authHeader } from "../../utils";

const login = body => post("login", {}, body);

const socialLogin = body => post("socialLogin", {}, body);

const forgotPassword = (headers, body) => post("forgotPassword", headers, body);

const resetPassword = (sessionId, body) =>
  put("resetPassword", `sessionId=${sessionId}`, {}, body);

const register = (type, body) => post(type, {}, body)

const getAccount = () =>
  // TODO move custom Headers from here
  get("account", { ...authHeader() });

export {
  forgotPassword,
  login,
  register,
  getAccount,
  socialLogin,
  resetPassword,
};



// WEBPACK FOOTER //
// ./src/stores/Login/loginStore.service.js